<template>
    <viewComponent :item="item" />
</template>
<script setup>
import { computed } from 'vue'
import AuditRiskDetails from './AuditRiskDetails'
import CompensationDetails from './CompensationDetails'
import Empty from './Empty'
import IncentivesActivityDetails from './IncentivesActivityDetails.vue'
import InsiderTransactionDetails from './InsiderTransactionDetails.vue'
import PledgedShareDetails from './PledgedShareDetails.vue'
import PremiumResearchDetails from './PremiumReseach/'
import TranscriptsDetails from './TranscriptsDetails.vue'
import WorkHistoryDetails from './WorkHistoryDetails.vue'
import ExecutionUpdateDetails from './ExecutionUpdateDetails.vue'

const components = {
    AuditRisk: AuditRiskDetails,
    Compensation: CompensationDetails,
    ExecutionAnalysis: ExecutionUpdateDetails,
    Incentives: IncentivesActivityDetails,
    InsiderTransaction: InsiderTransactionDetails,
    PledgedSecurity: PledgedShareDetails,
    PremiumResearch: PremiumResearchDetails,
    Transcripts: TranscriptsDetails,
    WorkHistory: WorkHistoryDetails,
}

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const viewComponent = computed(() => components[props.item?.type ?? ''] ?? Empty)
</script>
